module.exports = __webpack_public_path__ + "img/partners_sellArrow.666abc0d.svg";